import { http, ep } from '../../client/http';

export const whyUsRepo = {
  get: async () => {
    const res = await http.get(ep('whyUs'));
    return res.data.data; // <-- artık direkt {logo, favicon, ...} döner
  }
};
